import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import AddIcon from "@mui/icons-material/Add";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import PublicIcon from "@mui/icons-material/Public";
import RoomIcon from "@mui/icons-material/Room";
import { Box, Button, Card, Chip, Divider, IconButton, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Postrequestcall } from "../../request/Postrequest";
import { BIBlue } from "../../assets/helpers";
import AddAddress from "../common/AddAddress";
import AddPhoneNumberModal from "../common/AddPhoneNumberModal";
import AddTradeModal from "../common/AddTradeModal";
import AddWebsiteModal from "../common/AddWebsiteModal";
import DeleteConfirmation from "../common/DeleteConfirmation";
import Loader from "../../common/Loader";
import { DELETE_COMPANY_TRADE } from "../../constant/Apipath";
import { English } from "../../constant/EnglishFallback";

const ManufactureAboutSection = ({
  manufactureDetails,
  tradeList,
  manufactureAddress,
  onTradesSaveSuccessfully,
  onManufactureDetailsSaveSuccessfully,
  onManufactureAddressSaveSuccessfully,
  isVerified = false,
  color= ""
}) => {
  const { loginData } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;
  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.Manufacturers || {};

  const {
    TEXT_ABOUT_INFO = English.Manufacturers.TEXT_ABOUT_INFO,
    TEXT_ADD_EMAIL = English.Manufacturers.TEXT_ADD_EMAIL,
    TEXT_TRADE_COMPONY = English.Manufacturers.TEXT_TRADE_COMPONY,
    TEXT_ADD_WEBSITE = English.Manufacturers.TEXT_ADD_WEBSITE,
    TEXT_ADD_PHONE_NUMBER = English.Manufacturers.TEXT_ADD_PHONE_NUMBER,
    BUTTON_ADD_ANOTHER_ADDRESS = English.Manufacturers.BUTTON_ADD_ANOTHER_ADDRESS,
    TEXT_ADD_ADDRESS_TITLE = English.Manufacturers.TEXT_ADD_ADDRESS_TITLE,
    TEXT_DELETE_MANUFACTURERS_TARDES = English.Manufacturers.TEXT_DELETE_MANUFACTURERS_TARDES,
    TEXT_DELETE_COMPANY_TARDES_DEC = English.Manufacturers.TEXT_DELETE_COMPANY_TARDES_DEC
  } = LanguageData || {};

  const [showAddTradesModal, setShowAddTradeOpenModal] = useState(false);
  const [loading] = useState(false);
  const [selectedTradeId, setSelectedTradeId] = useState(0);
  const [confirmDeleteModalOpen, setConfirmDeleteModalOpen] = useState(false);
  const [basicDetailsModalType, setBasicDetailsModalType] = useState(null);
  const { pathname } = useLocation();

  const onTradeItemClick = (id) => {
    if (!id) return;
    setSelectedTradeId(id);
    setConfirmDeleteModalOpen(true);
  };

  const handleWebRedirect = (inputUrl) => {
    try {
      let fullUrl = new URL(inputUrl);
      let baseUrl = `${fullUrl.hostname}`;
      window.open(`http://${baseUrl}`, "_blank");
    } catch (error) {
      window.open(`http://${inputUrl}`, "_blank");
    }
  };

  const extractBaseURL = (inputUrl) => {
    try {
      let fullUrl = new URL(inputUrl);
      let baseUrl = `${fullUrl?.hostname}`;
      return baseUrl;
    } catch (error) {
      console.log("extractBaseURL-> Error When Extracting Base URL: ", error);
      return inputUrl;
    }
  };

  const handleDeleteTrade = async () => {
    try {
      const obj = {
        UserId: currentUserId,
        ReturnRecordError: true,
        SoftDelete: true,
        DeleteList: [
          {
            TradeId: selectedTradeId,
            CompanyId: manufactureDetails.id
          }
        ]
      };
      const res = await Postrequestcall(DELETE_COMPANY_TRADE, obj, loginData?.accessToken);
      if (res.status === 201) {
        onTradesSaveSuccessfully();
      } else {
        console.log("handleDeleteTrade-> Error When Deleting Company Trade");
      }
    } catch (error) {
      console.error("handleDeleteTrade-> Error When Deleting Company Trade: ", error);
    }
  };

  if (loading) {
    return <Loader />;
  }

  const isNOInfo =
    tradeList.length === 0 &&
    manufactureDetails?.address === "" &&
    manufactureDetails?.phone === "" &&
    manufactureDetails?.webSite === "";

  const renderNoManufacturer = () => {
    const emptyText = isVerified ? "No data added by admin" : "No data added";
    const emptySubText = isVerified
      ? "This section is managed by the manufacturer admin."
      : "Add manufacturer's details to make this section complete.";
    return (
      isNOInfo && (
        <Box
          sx={{
            mt: 1.5,
            mb: 1,
            px: 2,
            py: 2,
            borderRadius: 2,
            border: "1px solid",
            borderColor: "grey.200",
            bgcolor: isVerified ? "primary.50" : "grey.50"
          }}>
          <Stack direction="row" alignItems="center" spacing={1.5} justifyContent="center">
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: isVerified ? "primary.100" : "grey.200",
                color: isVerified ? "primary.main" : "text.secondary",
                flexShrink: 0
              }}>
              <InfoOutlinedIcon sx={{ fontSize: 20 }} />
            </Box>
            <Stack spacing={0.25} sx={{ textAlign: "left" }}>
              <Typography variant="body2" fontWeight={700} color="text.primary">
                {emptyText}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {emptySubText}
              </Typography>
            </Stack>
          </Stack>
        </Box>
      )
    );
  };

  const renderTradeList = () => {
    return (
      (tradeList?.length !== 0 || !pathname.includes("proxySite")) && (
        <>
          {tradeList?.length !== 0 ? (
            <Stack
              style={{
                marginTop: "2%",
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "10px 10px",
                paddingBottom: isVerified ? "0" : "15px"
              }}
              direction="row"
              spacing={0}>
              {tradeList
                ?.sort(
                  (a, b) =>
                    a.tradeType?.toLowerCase().localeCompare(b.tradeType?.toLowerCase()) ||
                    a.tradeName
                      ?.trim()
                      .toLowerCase()
                      .localeCompare(b.tradeName?.trim().toLowerCase())
                )
                .map((item, index) => {
                  return (
                    <Chip
                      size={isVerified ? "small" : "medium"}
                      key={index.toString()}
                      label={item.tradeName?.trim()}
                      style={{
                        cursor: !pathname.includes("proxySite") ? "pointer" : "default",
                        backgroundColor:
                          item?.tradeType?.toLowerCase() === "main" ? BIBlue : "null",
                        color: item?.tradeType?.toLowerCase() === "main" ? "white" : "null",
                        borderRadius: isVerified ? "5px" : "16px"
                      }}
                      onClick={() => {
                        // if (!pathname.includes("proxySite")) {
                        //   onTradeItemClick(item?.tradeId ?? 0);
                        // } else {
                        //   return;
                        // }
                      }}></Chip>
                  );
                })}
              {!pathname.includes("proxySite") && !isVerified && (
                <>
                  <IconButton
                    color="primary"
                    size="small"
                    onClick={() => {
                      setShowAddTradeOpenModal(true);
                    }}
                    style={{ backgroundColor: BIBlue, color: "white" }}>
                    <AddIcon style={{ fontSize: "16px" }} />
                  </IconButton>
                  {isVerified && <Divider />}
                </>
              )}
            </Stack>
          ) : (
            !pathname.includes("proxySite") &&
            !isVerified && (
              <>
                <Stack direction="row" paddingBottom={isVerified ? 0 : 2} style={{ marginTop: isVerified ? "0" : "10px" }}>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      setShowAddTradeOpenModal(true);
                    }}
                    style={{ borderRadius: "30px" }}>
                    {TEXT_TRADE_COMPONY}
                  </Button>
                </Stack>
                {isVerified && <Divider />}
              </>
            )
          )}
        </>
      )
    );
  };

  const renderEmail = () => {
    return (
      (!pathname.includes("proxySite") || manufactureDetails?.email) &&
      (manufactureDetails?.email ? (
        <>
          <Stack direction="row" spacing={2}>
            <EmailIcon color="primary" sx={{ color:color, textDecoration:'none' }} />
            <span
              style={{
                color: isVerified ===false ? BIBlue:"black",
                cursor: "pointer",
              }}>
              {manufactureDetails?.email}
            </span>
          </Stack>
          {isVerified && <Divider />}
        </>
      ) : (
        <>
          {!isVerified && (
            <>
              <Stack direction="row" alignItems={"center"} spacing={2}>
                <EmailIcon color="primary" sx={{ textDecoration:'none' }} />
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    setBasicDetailsModalType("email");
                  }}
                  style={{ width: "100%" }}>
                  {TEXT_ADD_EMAIL}
                </Button>
              </Stack>
              {isVerified && <Divider />}
            </>
          )}
        </>
      ))
    );
  };

  const renderWebsite = () => {
    return (
      (!pathname.includes("proxySite") || manufactureDetails?.webSite) && (
        <>
          {manufactureDetails?.webSite ? (
            <>
              <Stack direction="row" spacing={2}>
                <PublicIcon color="primary" sx={{ color:color }} />
                <span
                  style={{
                    color: BIBlue,
                    cursor: "pointer",
                    textDecoration: "underline"
                  }}
                  onClick={() => handleWebRedirect(manufactureDetails?.webSite)}>
                  {extractBaseURL(manufactureDetails?.webSite)}
                </span>
              </Stack>
              {isVerified && <Divider />}
            </>
          ) : (
            !isVerified && (
              <>
                <Stack direction="row" alignItems={"center"} spacing={2}>
                  <PublicIcon color="primary" sx={{ color:color }} />
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      setBasicDetailsModalType("website");
                    }}
                    style={{ width: "100%" }}>
                    {TEXT_ADD_WEBSITE}
                  </Button>
                </Stack>
                {isVerified && <Divider />}
              </>
            )
          )}
        </>
      )
    );
  };

  const renderPhoneNumber = () => {
    return (
      (!pathname?.includes("proxySite") || manufactureDetails?.phone) && (
        <>
          {manufactureDetails?.phone ? (
            <Stack direction="row" spacing={2}>
              <PhoneIcon color="primary" sx={{ color:color }} />
              <p>{manufactureDetails?.phone}</p>
            </Stack>
          ) : (
            !pathname?.includes("proxySite") &&
            !isVerified && (
              <>
                <Stack direction="row" alignItems={"center"} spacing={2}>
                  <PhoneIcon color="primary" sx={{ color:color }} />
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      setBasicDetailsModalType("phone");
                    }}
                    style={{ width: "100%" }}>
                    {TEXT_ADD_PHONE_NUMBER}
                  </Button>
                </Stack>
                {isVerified && <Divider />}
              </>
            )
          )}
        </>
      )
    );
  };

  const renderAddress = () => {
    return (
      (!pathname?.includes("proxySite") || manufactureAddress?.length > 0) && (
        <>
          {manufactureAddress?.length > 0 ? (
            <>
              {manufactureAddress.map((data, i) => (
                <div key={i}>
                  <Stack direction="row" spacing={2} key={i} style={i !== 0 ? { marginTop: "8px" } : {}}>
                    <RoomIcon color="primary" sx={{ color:color }} />
                    <Stack direction="column" spacing={0}>
                      <Typography>
                        {data?.address} {data?.city ? "," : ""} {data?.city}
                        {data?.province ? "," : ""} {data?.province}
                        {data?.postalCode ? "," : ""}
                        {data?.postalCode}
                        {data?.country ? "," : ""} {data?.country}
                      </Typography>
                    </Stack>
                  </Stack>
                </div>
              ))}
              {!pathname?.includes("proxySite") && !isVerified && (
                <>
                  <div style={{ marginTop: "8px", textAlign: "end" }}>
                    <Button
                      color="primary"
                      onClick={() => {
                        setBasicDetailsModalType("address");
                      }}>
                      {BUTTON_ADD_ANOTHER_ADDRESS}
                    </Button>
                  </div>
                </>
              )}
              {isVerified && <Divider />}
            </>
          ) : (
            !pathname?.includes("proxySite") && !isVerified && (
              <>
                <Stack direction="row" alignItems={"center"} spacing={2}>
                  <RoomIcon color="primary" sx={{ color:color }} />
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      setBasicDetailsModalType("address");
                    }}
                    style={{ width: "100%" }}>
                    {TEXT_ADD_ADDRESS_TITLE}
                  </Button>
                </Stack>
                {isVerified && <Divider />}
              </>
            )
          )}
        </>
      )
    );
  };

  // Render verified layout
  const renderVerifiedLayout = () => (
    <Card sx={{ p: "10px" }}>
      <Typography>{manufactureDetails?.description}</Typography>
      {renderNoManufacturer()}
      <Stack gap={2}>
        {renderTradeList()}
        {renderEmail()}
        {renderWebsite()}
        {renderPhoneNumber()}
        {renderAddress()}
      </Stack>
    </Card>
  );

  // Render unverified layout
  const renderUnverifiedLayout = () => (
    <Card className="pagelist-content" sx={{ p: 2, height: "100%" }}>
      <Typography variant="h6">{TEXT_ABOUT_INFO}</Typography>
      {renderNoManufacturer()}
      {renderTradeList()}
      <Stack gap={2}>
        {renderWebsite()}
        {renderPhoneNumber()}
        {renderAddress()}
      </Stack>
    </Card>
  );

  return (
    <>
      {/* Conditional rendering based on verification status */}
      {console.log('manufactureAddress============',manufactureAddress)}
      {isVerified ? renderVerifiedLayout() : renderUnverifiedLayout()}

      {/* Common Modals */}
      {showAddTradesModal && (
        <AddTradeModal
          open={showAddTradesModal}
          onClose={() => {
            setShowAddTradeOpenModal(false);
          }}
          alreadyTradesSelected={tradeList}
          mainId={manufactureDetails?.id}
          onTradesSaveSuccessfully={onTradesSaveSuccessfully}
        />
      )}

      {basicDetailsModalType === "website" && (
        <AddWebsiteModal
          open={true}
          onClose={() => {
            setBasicDetailsModalType(null);
          }}
          from="manufacture"
          data={manufactureDetails}
          onDataSave={onManufactureDetailsSaveSuccessfully}
          {...(!isVerified && { onSaveClick: () => {} })}
        />
      )}

      {basicDetailsModalType === "phone" && (
        <AddPhoneNumberModal
          open={true}
          onClose={() => {
            setBasicDetailsModalType(null);
          }}
          from="manufacture"
          data={manufactureDetails}
          onDataSave={onManufactureDetailsSaveSuccessfully}
        />
      )}

      {basicDetailsModalType === "email" && (
        <AddPhoneNumberModal
          open={true}
          onClose={() => {
            setBasicDetailsModalType(null);
          }}
          from="manufacture"
          data={manufactureDetails}
          onDataSave={onManufactureDetailsSaveSuccessfully}
        />
      )}

      {confirmDeleteModalOpen && (
        <DeleteConfirmation
          open={confirmDeleteModalOpen}
          onClose={() => setConfirmDeleteModalOpen(false)}
          headerText={TEXT_DELETE_MANUFACTURERS_TARDES}
          secondaryText={TEXT_DELETE_COMPANY_TARDES_DEC}
          onBadgeClick={handleDeleteTrade}
        />
      )}

      {basicDetailsModalType === "address" && (
        <AddAddress
          open={true}
          onClose={() => {
            setBasicDetailsModalType(null);
          }}
          from="manufacture"
          data={manufactureDetails}
          onDataSave={onManufactureAddressSaveSuccessfully}
        />
      )}
    </>
  );
};

export default ManufactureAboutSection;
